import { Checkbox, typography } from '@joor/design-system'
import styled from 'styled-components'

export const Container = styled.div`
  padding: 16px 0 0;
  margin: 8px 0 16px;
  border-radius: 3px;
  background-color: var(--color-secondary-100);
  display: flex;
  flex-direction: column;
`

export const SummaryWrapper = styled.div`
  background: white;
  padding: 0px 8px;
`

export const ButtonLink = styled.button`
  padding: 20px 0px 20px 16px;
  font: ${typography.alpha.primaryActive.body3}
  color: var(--color-secondary-800);
  background: transparent;
  border: none;
  text-decoration: none;
  display: inline-block;
  width: fit-content;
  cursor: pointer;
`

export const DownloadingMessage = styled.div`
  margin: 17px 0px 17px 16px;
  color: var(--color-primary-800);
  display: inline-block;
  width: fit-content;
`

export const StyledCheck = styled(Checkbox)`
  display: flex !important;
  flex-direction: row-reverse;
  margin: 8px 0 0 16px;
  font: ${typography.alpha.primaryActive.body3}
  color: var(--color-primary-800) !important;
`

export const StyledErrors = styled.label`
  margin: 0px 0px 8px 16px;
  color: var(--color-primary-800) !important;
  font: ${typography.alpha.primaryActive.body3};
`

export const StyledErrorTitle = styled.label`
  margin: 0;
  color: var(--color-primary-800) !important;
  font-size: var(--size-font-medium);
  font-weight: var(--font-weight-medium);
  font: ${typography.alpha.primaryActive.heading3};
`
